import client from './api-client';

export const getConfiguracionForm36 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form36: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const postConfirmarRecobro = async(file) => {
    try {
        
        const response = await client.post('recobro/visar', file);
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaConfirmar: response.data};
        } else {
            return {respuestaConfirmar: response.data};
        }
        
    } catch(error){
        throw error;
    }
}
export const getAntecedentesRecobro = async(query) => {
    try {
        
        const response = await client.get(`gestion-implicado/recobros?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                antecedentesRecobro: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}